




































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class CheckboxGroupWidget extends Vue {

  @Inject() public $validator: any;

  @Prop([String, Array]) private tooltipText!: string | string[];
  @Prop(Array) private checkboxes!: any[];
  @Prop() private dataModel!: any;
  @Prop({ type: String, default: 'payrollForm' }) private formName!: string;
  @Prop(String) private staticInputId!: string;
  @Prop(String) private checkboxTitle!: string;
  @Prop(String) private checkboxErrorTitle!: string;
  @Prop(String) private checkboxContent!: string;
  @Prop(String) private checkboxName!: string;
  @Prop(String) private initialValue!: string;
  @Prop(Boolean) private isRequired!: boolean;
  @Prop(Boolean) private showWarningIcon!: boolean;
  @Prop(Boolean) private showCheckboxTitle!: boolean;
  @Prop(Boolean) private showTooltip!: boolean;
  @Prop(Boolean) private isDisabled!: boolean;

  private inputId: string | number | boolean = '';
  private inputModel: any = {};

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.inputModel = this.dataModel;
  }

  public onInput(): void {
    this.$emit('onInput', this.inputModel);
    this.$emit('input', this.inputModel);
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = true;
      for (const key in this.inputModel) {
        if (this.inputModel[key]) {
          validator.isRequired = false;
        }
      }
    }
    return validator;
  }

}
